export default class MoreServices {
	constructor(container) {
		this.slider = container.querySelector('.slider');
		this.container = container;

    this.slideWidth = container.querySelector('.item').offsetWidth + 32;
    this.sliderWidth = this.slider.scrollWidth;

		this.leftButton = this.container.querySelector('.previous_service');
		this.rightButton = this.container.querySelector('.next_service');

		this.buttonSnappingScroll();
		this.manualScrollChangeColors();
  };

	// Controls the buttons, thier snapping motion and the colors of the chevrons
	buttonSnappingScroll() {
		this.leftButton.addEventListener('click', () => {
			this.slider.scroll({
				left: this.scrollBackDistance(),
				behavior: 'smooth'
			});
		});

		this.rightButton.addEventListener('click', () => {
			this.slider.scroll({
				left: this.scrollForwardDistance(),
				behavior: 'smooth'
			});
		});
	}

	// For changing colors on manual user scroll
	manualScrollChangeColors() {
		const context = this;
		this.slider.addEventListener('scroll', this.scrollBackDistance.bind(context));
		this.slider.addEventListener('scroll', this.scrollForwardDistance.bind(context));
	}

	scrollForwardDistance() {
		let scrollForwardDistance = this.slider.scrollLeft -
			this.overlappingSlidePixelsLeftside() + this.slideWidth;

		if (scrollForwardDistance === Math.ceil(this.slider.scrollLeft)) {
			scrollForwardDistance += this.slideWidth;
		}

		if (
			this.slider.scrollLeft +
			 	this.slider.offsetWidth >= this.sliderWidth
		) {
			this.rightButton.querySelector('img').src =
				this.rightButton.dataset.disabledImgLink;
		} else if (scrollForwardDistance !== 0) {
			this.rightButton.querySelector('img').src =
				this.rightButton.dataset.imgLink;
		}

		return scrollForwardDistance;
	}

	scrollBackDistance() {
		let scrollBackDistance = this.slider.scrollLeft -
			(this.overlappingSlidePixelsLeftside() || this.slideWidth);

		if (scrollBackDistance === Math.floor(this.slider.scrollLeft)) {
			scrollBackDistance -= this.slideWidth;
		}

		if (this.slider.scrollLeft === 0) {
			this.leftButton.querySelector('img').src =
				this.leftButton.dataset.disabledImgLink;
		} else {
			this.leftButton.querySelector('img').src =
				this.leftButton.dataset.imgLink;
		}

		return scrollBackDistance;
	}

	overlappingSlidePixelsLeftside() {
		return (this.slider.scrollLeft % this.slideWidth);
	}
};
